export default __webpack_public_path__ + "static/media/response-mobile.91e56876.svg";